import { render } from "./UpdateReservationDaysModal.vue?vue&type=template&id=6bb9060f"
import script from "./UpdateReservationDaysModal.vue?vue&type=script&lang=js"
export * from "./UpdateReservationDaysModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__